// import { Button, notification } from "antd";
// import moment from "moment";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { API } from "../../../../config/Api";
// import { POST } from "../../../../utils/apiRequest";
// import PauseResumeModal from "./pauseResumeModal";
// import { IoPauseCircleOutline } from "react-icons/io5";

// const PauseScreen = ({ data, getUser }: any) => {
//   const holdResume = data?.holdResume;
//   const user = useSelector((state: any) => state?.User?.user);
//   const [activeModal, setActiveModal] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   const showModal = () => {
//     setActiveModal(true);
//   };

//   const closeModal = () => {
//     setActiveModal(false);
//   };

//   const submit = async (from: any, to: any, days: any) => {
//     try {

//       setIsLoading(true);
//       const payload = {
//         user_id: data?.user?.id,
//         current_exp: data?.end_date,
//         hold_from: from?.format(),
//         hold_to: to?.format(),
//         num_days: days,
//         type: holdResume?.id ? "resume" : "pause",
//         office_id: user?.office?.id,
//         new_exp: holdResume?.id
//           ? moment(data?.end_date).add(days, "days").format()
//           : null,
//       };
//       const response: any = await POST(API.HOLD_RESUME_ADD, payload);

//       if (response?.status) {
//         notification.success({
//           message: "Success",
//           description: holdResume?.id
//             ? "Subscription resumed successfully."
//             : "Subscription paused successfully.",
//         });
//         getUser();
//         setIsLoading(false);
//         closeModal();
//       }
//     } catch (error) {
//       console.error(error);
//       setIsLoading(false);
//       notification.error({
//         message: "Error",
//         description: "Something went wrong. Please try again.",
//       });
//     }
//   };

//   return (
//     <div>
//       <Button
//         className={holdResume?.id ? "text-success" : "text-warning"}
//         onClick={showModal}
//         style={{ height: holdResume?.id && "60px" }}
//       >
//         <IoPauseCircleOutline className="me-2" size={18} />
//         <span>{holdResume?.id ? "Resume" : "Pause"} Subscription</span>
//         {holdResume && (
//           <div>
//             {`Hold period ${moment(holdResume?.hold_from).format(
//               "DD MMMM"
//             )} to ${moment(holdResume?.hold_to).format("DD MMMM")} - ${
//               holdResume?.num_days
//             } days`}
//           </div>
//         )}
//       </Button>
//       {activeModal && (
//         <PauseResumeModal
//           data={data}
//           isModalOpen={activeModal}
//           handleCancel={closeModal}
//           onSubmit={submit}
//           holdResume={holdResume}
//           isLoading={isLoading}
//         />
//       )}
//     </div>
//   );
// };

// export default PauseScreen;

import React, { useState } from "react";
import { Button, notification } from "antd";
import { IoPauseCircleOutline, IoPlayCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import dayjs, { Dayjs } from "dayjs";
import { API } from "../../../../config/Api";
import { POST } from "../../../../utils/apiRequest";
import PauseResumeModal from "./pauseResumeModal";

interface HoldResumeType {
  id?: string;
  hold_from: string;
  hold_to: string;
  num_days: number;
  current_exp: string;
}

interface UserData {
  holdResume?: HoldResumeType;
  user: {
    id: string;
  };
  end_date: string;
}

interface UserState {
  User: {
    user: {
      office: {
        id: string;
      };
    };
  };
}

interface ApiResponse {
  status: boolean;
  message?: string;
  data?: any;
}

interface PauseScreenProps {
  data: UserData;
  getUser: () => void;
}

const PauseScreen: React.FC<PauseScreenProps> = ({ data, getUser }: any) => {
  const holdResume = data?.holdResume;
  const user = useSelector((state: UserState) => state?.User?.user);
  const [activeModal, setActiveModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isPaused = Boolean(holdResume?.id);

  const submit = async (from: Dayjs, to: Dayjs, days: number) => {
    try {
      setIsLoading(true);

      let payload;
      if (isPaused) {
        // Resume payload
        payload = {
          user_id: data?.user?.id,
          current_exp: holdResume?.current_exp,
          type: "resume",
          office_id: user?.office?.id,
          hold_resume_id: holdResume?.id,
        };
      } else {
        // Pause payload
        payload = {
          user_id: data?.user?.id,
          current_exp: data?.user?.end_date,
          hold_from: from.format("YYYY-MM-DD"),
          hold_to: to.format("YYYY-MM-DD"),
          num_days: days,
          type: "pause",
          office_id: user?.office?.id,
        };
      }

      const response = (await POST(
        API.HOLD_RESUME_ADD,
        payload
      )) as ApiResponse;

      if (response?.status) {
        notification.success({
          message: "Success",
          description: isPaused
            ? "Subscription resumed successfully."
            : "Subscription paused successfully.",
        });
        getUser();
        setActiveModal(false);
      } else {
        notification.error({
          message: "Error",
          description:
            response?.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error in submit:", error);
      notification.error({
        message: "Error",
        description: "Something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Button
        className={`d-flex align-items-center ${
          isPaused ? "text-success" : "text-warning"
        }`}
        onClick={() => setActiveModal(true)}
        style={{
          height: "auto",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "8px 12px",
        }}
      >
        <div className="d-flex align-items-center">
          {isPaused ? (
            <IoPlayCircleOutline className="me-2" size={18} />
          ) : (
            <IoPauseCircleOutline className="me-2" size={18} />
          )}
          <span>{isPaused ? "Resume" : "Pause"} Subscription</span>
        </div>
        {isPaused && holdResume && (
          <div className="small text-muted mt-1">
            {`Hold period ${dayjs(holdResume.hold_from).format(
              "DD MMMM"
            )} to ${dayjs(holdResume.hold_to).format("DD MMMM")} - ${
              holdResume.num_days
            } days`}
          </div>
        )}
      </Button>

      <PauseResumeModal
        data={data}
        isModalOpen={activeModal}
        handleCancel={() => setActiveModal(false)}
        onSubmit={submit}
        holdResume={holdResume}
        isLoading={isLoading}
        isPaused={isPaused}
      />
    </div>
  );
};

export default PauseScreen;
